/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Meta_Pagetitle1Inputs */

const ja_work_meta_pagetitle1 = /** @type {(inputs: Work_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Work`)
};

const en_work_meta_pagetitle1 = /** @type {(inputs: Work_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Work`)
};

/**
* | output |
* | --- |
* | "Our Work" |
*
* @param {Work_Meta_Pagetitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const work_meta_pagetitle1 = /** @type {((inputs?: Work_Meta_Pagetitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Meta_Pagetitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_meta_pagetitle1(inputs)
	return en_work_meta_pagetitle1(inputs)
});
export { work_meta_pagetitle1 as "work_meta_pageTitle" }